import { render } from "./list-branch.vue?vue&type=template&id=c3cc5efa"
import script from "./list-branch.vue?vue&type=script&lang=js"
export * from "./list-branch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__